<template>
  <div class="TranUserPackageActivityReminder-detail-page w-100">
    <b-form @submit="handleValidate">
      <basic-subheader>
        <template v-slot:actions>
          <b-button
            class="btn btn-light ml-3"
            type="button"
            @click="returnPage"
          >
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
            </span>
            Huỷ
          </b-button>
          <b-button class="btn btn-light ml-3" type="button" @click="resetData">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
            </span>
            Reset dữ liệu
          </b-button>
          <template>
            <b-button class="btn btn-success ml-3" @click.stop="handleValidate">
              <span class="svg-icon">
                <inline-svg
                  :src="`/media/svg/icons/Neolex/Basic/${
                    isCreateForm ? 'plus' : 'save'
                  }.svg`"
                />
              </span>
              {{ isCreateForm ? 'Tạo mới' : ' Cập nhật' }}
            </b-button>
          </template>
        </template>
      </basic-subheader>
      <b-overlay :show="loading">
        <b-container fluid class="TranUserPackageActivityReminder-list-page__body mb-6 mt-6">
          <b-row>
            <b-col>
              <div class="card card-custom gutter-b w-100">
                <div class="card-body mt-0">
                  <h5 class="card-title text-success">
                    Thông tin TranUserPackageActivityReminder
                  </h5>
                  <b-row>
                    <!-- <b-col cols="1">
                          <template v-if="form_type === 'edit'">
                            <h5 class="mt-4">{{ form.id }}</h5>
                            <div>
                              <span>Mã số: {{ form.id }}</span>
                            </div>
                            <div class="d-flex align-items-center mt-2">
                              <span
                                class="btn btn-active"
                                style="width: 95px; cursor: default"
                                v-if="form.status === 1">
                                Active
                              </span>
                              <span
                                class="btn btn-inactive"
                                style="width: 95px; cursor: default"
                                v-if="form.status === 0">
                                Inactive
                              </span>
                              <span
                                class="btn btn-TranUserPackageActivityReminder ml-3"
                                style="width: 95px; cursor: default">
                                Portal User
                              </span>
                            </div>
                          </template>
                    </b-col> -->
                    <b-col>
                      <b-row>
                        
                        <b-row>
                            <b-col>
                                <basic-input
                                 label= "Code"
                                 placeholder="Code"
                                 name="code"
                                 data-vv-As="Code"
                                 :required="true"
                                 v-validate="'required'"
                                 :value.sync="form.code"
                                  :state="validateState('code')"
                                 :invalidFeedback="errors.first('code')"
                                 ></basic-input>
                            </b-col>
                            <b-col>
                                
         
                                 <basic-select
         
                                 label="UserPackage"
         
                                 placeholder="--- Chọn UserPackage ---"
         
                                 track-by="value"
         
                                 value-label="text"
         
                                 :options="userPackages"
         
                                 :value.sync="form.selecteduserPackage"
         
                                 :allow-empty="true"
         
                                 required
         
                                 multiple
         
                                 name="userPackage"
         
                                 v-validate="'required'"
         
                                 :state="validateState('userPackage')"
         
                                 :invalidFeedback="errors.first('UserPackage')"
         
                                 data-vv-as="userPackage"
         
                                 changeValueByObject
         
                                 :disabled="diableInputWithPosition"
         
                                 @update:value="resetDropdown('userPackage')"
         
                                 @input="handleChangeSelect($event, 'userPackage')"
         
                                 />
    
                            </b-col>
                            <b-col>
                                
         
                                 <basic-select
         
                                 label="TranServicePackage"
         
                                 placeholder="--- Chọn TranServicePackage ---"
         
                                 track-by="value"
         
                                 value-label="text"
         
                                 :options="tranServicePackages"
         
                                 :value.sync="form.selectedtranServicePackage"
         
                                 :allow-empty="true"
         
                                 required
         
                                 multiple
         
                                 name="tranServicePackage"
         
                                 v-validate="'required'"
         
                                 :state="validateState('tranServicePackage')"
         
                                 :invalidFeedback="errors.first('TranServicePackage')"
         
                                 data-vv-as="tranServicePackage"
         
                                 changeValueByObject
         
                                 :disabled="diableInputWithPosition"
         
                                 @update:value="resetDropdown('tranServicePackage')"
         
                                 @input="handleChangeSelect($event, 'tranServicePackage')"
         
                                 />
    
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                
         
                                 <basic-select
         
                                 label="TranProgram"
         
                                 placeholder="--- Chọn TranProgram ---"
         
                                 track-by="value"
         
                                 value-label="text"
         
                                 :options="tranPrograms"
         
                                 :value.sync="form.selectedtranProgram"
         
                                 :allow-empty="true"
         
                                 required
         
                                 multiple
         
                                 name="tranProgram"
         
                                 v-validate="'required'"
         
                                 :state="validateState('tranProgram')"
         
                                 :invalidFeedback="errors.first('TranProgram')"
         
                                 data-vv-as="tranProgram"
         
                                 changeValueByObject
         
                                 :disabled="diableInputWithPosition"
         
                                 @update:value="resetDropdown('tranProgram')"
         
                                 @input="handleChangeSelect($event, 'tranProgram')"
         
                                 />
    
                            </b-col>
                            <b-col>
                                
         
                                 <basic-select
         
                                 label="TranProgramModule"
         
                                 placeholder="--- Chọn TranProgramModule ---"
         
                                 track-by="value"
         
                                 value-label="text"
         
                                 :options="tranProgramModules"
         
                                 :value.sync="form.selectedtranProgramModule"
         
                                 :allow-empty="true"
         
                                 required
         
                                 multiple
         
                                 name="tranProgramModule"
         
                                 v-validate="'required'"
         
                                 :state="validateState('tranProgramModule')"
         
                                 :invalidFeedback="errors.first('TranProgramModule')"
         
                                 data-vv-as="tranProgramModule"
         
                                 changeValueByObject
         
                                 :disabled="diableInputWithPosition"
         
                                 @update:value="resetDropdown('tranProgramModule')"
         
                                 @input="handleChangeSelect($event, 'tranProgramModule')"
         
                                 />
    
                            </b-col>
                            <b-col>
                                
         
                                 <basic-select
         
                                 label="TranProgramActivity"
         
                                 placeholder="--- Chọn TranProgramActivity ---"
         
                                 track-by="value"
         
                                 value-label="text"
         
                                 :options="tranProgramActivitys"
         
                                 :value.sync="form.selectedtranProgramActivity"
         
                                 :allow-empty="true"
         
                                 required
         
                                 multiple
         
                                 name="tranProgramActivity"
         
                                 v-validate="'required'"
         
                                 :state="validateState('tranProgramActivity')"
         
                                 :invalidFeedback="errors.first('TranProgramActivity')"
         
                                 data-vv-as="tranProgramActivity"
         
                                 changeValueByObject
         
                                 :disabled="diableInputWithPosition"
         
                                 @update:value="resetDropdown('tranProgramActivity')"
         
                                 @input="handleChangeSelect($event, 'tranProgramActivity')"
         
                                 />
    
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                
         
                                 <basic-select
         
                                 label="TranProgramActivityReminder"
         
                                 placeholder="--- Chọn TranProgramActivityReminder ---"
         
                                 track-by="value"
         
                                 value-label="text"
         
                                 :options="tranProgramActivityReminders"
         
                                 :value.sync="form.selectedtranProgramActivityReminder"
         
                                 :allow-empty="true"
         
                                 required
         
                                 multiple
         
                                 name="tranProgramActivityReminder"
         
                                 v-validate="'required'"
         
                                 :state="validateState('tranProgramActivityReminder')"
         
                                 :invalidFeedback="errors.first('TranProgramActivityReminder')"
         
                                 data-vv-as="tranProgramActivityReminder"
         
                                 changeValueByObject
         
                                 :disabled="diableInputWithPosition"
         
                                 @update:value="resetDropdown('tranProgramActivityReminder')"
         
                                 @input="handleChangeSelect($event, 'tranProgramActivityReminder')"
         
                                 />
    
                            </b-col>
                            <b-col>
                                <basic-input
                                 label= "JobId"
                                 placeholder="JobId"
                                 name="jobId"
                                 data-vv-As="JobId"
                                 :required="true"
                                 v-validate="'required'"
                                 :value.sync="form.jobId"
                                  :state="validateState('jobId')"
                                 :invalidFeedback="errors.first('jobId')"
                                 ></basic-input>
                            </b-col>
                            <b-col>
                                <basic-input
                                 label= "CallbackContent"
                                 placeholder="CallbackContent"
                                 name="callbackContent"
                                 data-vv-As="CallbackContent"
                                 :required="false"
                                 v-validate="'required'"
                                 :value.sync="form.callbackContent"
                                  :state="validateState('callbackContent')"
                                 :invalidFeedback="errors.first('callbackContent')"
                                 ></basic-input>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <basic-input
                                 label= "ReminderDatetime"
                                 placeholder="ReminderDatetime"
                                 name="reminderDatetime"
                                 data-vv-As="ReminderDatetime"
                                 :required="true"
                                 v-validate="'required'"
                                 :value.sync="form.reminderDatetime"
                                  :state="validateState('reminderDatetime')"
                                 :invalidFeedback="errors.first('reminderDatetime')"
                                 ></basic-input>
                            </b-col>
                        </b-row>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
                <div
                  class="card-footer d-flex align-items-lg-center justify-content-center"
                >
                  <b-button
                    class="btn btn-light ml-3"
                    type="button"
                    @click.stop="resetData"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                      />
                    </span>
                    Reset dữ liệu
                  </b-button>
                  <b-button
                    class="btn btn-success ml-3"
                    @click.stop="handleValidate"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/save.svg"
                      />
                    </span>
                    {{ isCreateForm ? 'Tạo mới' : 'Cập nhật' }}
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import 'vue2-datepicker/index.css';
export default {
  components: {
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
  },
  data() {
    return {
      
      tranServicePackages: [
        { id: '1', text: 'Option 1' },
      ],
      selectedtranServicePackage: 0,
      
      tranPrograms: [
        { id: '1', text: 'Option 1' },
      ],
      selectedtranProgram: 0,
      
      tranProgramModules: [
        { id: '1', text: 'Option 1' },
      ],
      selectedtranProgramModule: 0,
      
      tranProgramActivitys: [
        { id: '1', text: 'Option 1' },
      ],
      selectedtranProgramActivity: 0,
      
      tranProgramActivityReminders: [
        { id: '1', text: 'Option 1' },
      ],
      selectedtranProgramActivityReminder: 0,
      
      form: {},
      file: null,
      preview: null,
      loading: false,
    };
  },
  created() {
    this.initDataInSelect();
    this.loadTranUserPackageActivityReminderData();
  },
  computed: {
    nationId() {
      return this.form.nation?.id;
    },
    provinceId() {
      return this.form.province?.id;
    },
    districtId() {
      return this.form.district?.id;
    },
    isCreateForm() {
      return this.form_type === 'create' || this.form_type === 'copy';
    },
  },
methods: {
    selected(value, formProperty, optionsArr) {
      this.form[formProperty] = value
        ? optionsArr.find((el) => el.value === value)
        : null;
      if (this.form[formProperty]) {
        this.$validator.reset({ name: formProperty });
      }
    },
    resetData() {   
               
          this.form.code = null;             
          this.form.userPackageId = null;             
          this.form.tranServicePackageId = null;             
          this.form.tranProgramId = null;             
          this.form.tranProgramModuleId = null;             
          this.form.tranProgramActivityId = null;             
          this.form.tranProgramActivityReminderId = null;             
          this.form.jobId = null;             
          this.form.callbackContent = null;             
          this.form.reminderDatetime = null;        
    },
    handleChangeSelect(value, formProperty) {
      console.log('isShowError', this.isShowError);
      var newOptions = value ? value[0] : null; 
      switch (formProperty) {        
        case 'tranServicePackage':
          this.selectedtranServicePackage = newOptions;
          break;
        case 'tranProgram':
          this.selectedtranProgram = newOptions;
          break;
        case 'tranProgramModule':
          this.selectedtranProgramModule = newOptions;
          break;
        case 'tranProgramActivity':
          this.selectedtranProgramActivity = newOptions;
          break;
        case 'tranProgramActivityReminder':
          this.selectedtranProgramActivityReminder = newOptions;
          break;
        default:
          break;
      }
    },

    async initDataInSelect() {
      try {
        this.loading = true;

        const [tranServicePackageList,tranProgramList,tranProgramModuleList,tranProgramActivityList,tranProgramActivityReminderList,] = await Promise.all([this.$api.get(`/tranServicePackage`, { params: { size: 1000 } }),this.$api.get(`/tranProgram`, { params: { size: 1000 } }),this.$api.get(`/tranProgramModule`, { params: { size: 1000 } }),this.$api.get(`/tranProgramActivity`, { params: { size: 1000 } }),this.$api.get(`/tranProgramActivityReminder`, { params: { size: 1000 } }),
        ]);

         this.tranServicePackages = this.mapDataSelect(tranServicePackageList);
        this.tranPrograms = this.mapDataSelect(tranProgramList);
        this.tranProgramModules = this.mapDataSelect(tranProgramModuleList);
        this.tranProgramActivitys = this.mapDataSelect(tranProgramActivityList);
        this.tranProgramActivityReminders = this.mapDataSelect(tranProgramActivityReminderList);
      } catch (error) {
        console.error('Error fetching data:', error);
        // Handle error appropriately, e.g., show error message
      } finally {
        this.loading = false;
      }
    },
    mapDataSelect(response) {
      return response?.data.items.map((value) => {
        return {
          id: value?.id,
          text: value?.name ?? value?.description,
        };
      });
    },
    clear() {
      this.preview = null;
    },
    notBeforeToday(date) {
      return date > new Date();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async returnPage() {
      (await this.handleConfirm())
        ? this.$router.push({
            name: 'tran_user_package_activity_reminder_list',
          })
        : null;
    },
    async handleConfirm() {
      let confirm = await this.$swal({
        text: 'Các thay đổi sẽ không được lưu trữ, bạn có chắc muốn huỷ?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Huỷ',
            value: true,
            visible: true,
            className: 'btn-warning',
            closeModal: true,
          },
        },
      });
      return confirm;
    },
    async handleValidate() {
      let result = await this.$validator.validateAll();
      if (!result) {
        return;
      } else {
        this.submit();
      }
    },
    async submit() {
      let payload = new FormData();
      const isCreateForm = this.isCreateForm;      
        this.form.code && 
          payload.append('code', this.form.code);      
        this.form.jobId && 
          payload.append('jobId', this.form.jobId);      
        this.form.callbackContent && 
          payload.append('callbackContent', this.form.callbackContent);      
        this.form.reminderDatetime && 
          payload.append('reminderDatetime', this.form.reminderDatetime);
      
         this.selectedtranServicePackage && 
          payload.append('tranServicePackageId', this.selectedtranServicePackage.id);      
        this.selectedtranProgram && 
          payload.append('tranProgramId', this.selectedtranProgram.id);      
        this.selectedtranProgramModule && 
          payload.append('tranProgramModuleId', this.selectedtranProgramModule.id);      
        this.selectedtranProgramActivity && 
          payload.append('tranProgramActivityId', this.selectedtranProgramActivity.id);      
        this.selectedtranProgramActivityReminder && 
          payload.append('tranProgramActivityReminderId', this.selectedtranProgramActivityReminder.id);
      let confirm = await this.$swal({
        text: `${
          isCreateForm
            ? 'Bạn có chắc muốn tạo TranUserPackageActivityReminder mới này không? '
            : 'Bạn có chắc muốn cập nhật thông tin TranUserPackageActivityReminder này hay không?'
        }`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });
      if (confirm) {
        if (isCreateForm) {
          this.handleCreate(payload);
        } else {
          this.handleUpdate(payload);
        }
      }
    },
    async handleCreate(payload) {
      try {
        this.loading = true;
        await this.$api.post(`TranUserPackageActivityReminder`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, TranUserPackageActivityReminder mới đã được tạo!',
        });
        this.$router.push({ name: 'tran_user_package_activity_reminder_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: e.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async handleUpdate(payload) {
      payload.append('id', this.form.id);
      try {
        this.loading = true;
        const id = this.form.id;
        await this.$api.put(`TranUserPackageActivityReminder/${id}`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, TranUserPackageActivityReminder đã được cập nhật!',
        });
        this.$router.push({ name: 'tran_user_package_activity_reminder_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: e.message,
        });
      } finally {
        this.loading = false;
      }
    },

    async loadTranUserPackageActivityReminderData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`TranUserPackageActivityReminder/${id}`);        
        this.form = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pictureInput {
  position: relative;
}
.icon-edit {
  z-index: 100;
  position: absolute;
  top: -15px;
  right: -6px;
  padding: 2px 6px;
  box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
}
.aterisk {
  color: #f64e60;
  font-size: 0.9rem;
}
</style>
